import { Component, Input } from "@angular/core";
import { Router } from "@angular/router";
import { ApiService } from "src/app/services/api.service";

@Component({
  selector: "botao-logout",
  template: `<ion-buttons>
    <ion-button (click)="logout()">
      <ion-icon name="log-out" slot="icon-only"></ion-icon>
    </ion-button>
  </ion-buttons>`,
})
export class BotaoLogoutComponent {
  @Input() menu: string;
  constructor(private authService: ApiService, private route: Router) {}

  async logout() {
    await this.authService.logout();
  }
}
